import { render } from "./VODListModal.vue?vue&type=template&id=6710e826"
import script from "./VODListModal.vue?vue&type=script&lang=js"
export * from "./VODListModal.vue?vue&type=script&lang=js"

import "./VODListModal.vue?vue&type=style&index=0&id=6710e826&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/VODListModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6710e826"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6710e826', __exports__)) {
    api.reload('6710e826', __exports__)
  }
  
  module.hot.accept("./VODListModal.vue?vue&type=template&id=6710e826", () => {
    api.rerender('6710e826', render)
  })

}


export default __exports__